module.exports = __webpack_public_path__ + "static/media/kavaha.6ae5b76e.png";